import React, { useEffect }        from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { usePrefStates }                    from './usePrefStates';
import { useSystemModals, useSystemToasts } from './useSystem';
import { GlobalSettingsDialog }             from "@src/views/pages/projects/operations/GlobalSettingsDialog";
import { CorvalProject, Uuid }              from "@src/types";
import _                                    from "underscore";


interface UseSystemSettingsHook {

    showSystemSettings(): void,

    getVisibleProjectSettings(): Uuid[],

    filterProjectsByVisibility( projects: Partial<CorvalProject>[] | Record<string, any>[], idAttribute?: string ): [ visibleProjects: Partial<CorvalProject>[] | Record<string, any>[], isEmpty: boolean ],
}

export const useSystemSettings = (): UseSystemSettingsHook => {

    const history                         = useHistory(),
          location                        = useLocation(),
          toastActions                    = useSystemToasts(),
          modalActions                    = useSystemModals(),
          [ prefState, prefs, prefEnums ] = usePrefStates();

    useEffect( () => {}, [ prefState ] );

    const showSystemSettings: UseSystemSettingsHook['showSystemSettings'] = () => {

        modalActions.show(
            <GlobalSettingsDialog/>, {
                // size:  'small',
                // style: { maxWidth: `80vw` }
            }
        );
    };

    const getVisibleProjectSettings: UseSystemSettingsHook['getVisibleProjectSettings'] = () => {

        return prefs.get( prefEnums.GLOBAL_ACTIVE_PROJECT_VISIBILITY ) as Uuid[];
    }

    const filterProjectsByVisibility: UseSystemSettingsHook['filterProjectsByVisibility'] = ( projects = [], idAttribute = 'id' ) => {

        if( !_.isEmpty( getVisibleProjectSettings() ) ){

            const visibleProjects = projects.filter( project => {
                return _.has( project, idAttribute )
                       ? getVisibleProjectSettings().includes( project[ idAttribute ] )
                       : false;
            } );

            const isEmpty = _.isEmpty( visibleProjects );

            return [ visibleProjects, isEmpty ];
        }

        return [ projects, _.isEmpty( projects ) ];
    }

    return {
        showSystemSettings,
        getVisibleProjectSettings,
        filterProjectsByVisibility,
    }
};
